//console.log('I´m custom js'); 
//$(document).on('click','.navbar-main .collapse a', function(e){
//    $(this).closest('.collapse').collapse('hide');
//});
